import type { EquipmentDataQueryCache } from '../api';
import type { ShortInventoryDto } from '@entities/equipmentInventory/@x/equipment';

export const addShortInventoryToEquipmentCache = ({
    previous,
    warehouseId,
    inventory,
}: {
    previous: EquipmentDataQueryCache | undefined;
    warehouseId: number;
    inventory: ShortInventoryDto;
}): EquipmentDataQueryCache | undefined => {
    if (!previous?.data.response.equipment) {
        return previous;
    }

    return {
        ...previous,
        data: {
            ...previous.data,
            response: {
                ...previous.data.response,
                equipment: previous.data.response.equipment.map((warehouse) => {
                    if (warehouse.id !== warehouseId) {
                        return warehouse;
                    }

                    return {
                        ...warehouse,
                        items: [...warehouse.items, inventory],
                    };
                }),
            },
        },
    };
};
